import React from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ScrollToTop } from "./components/common";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Photography from "./pages/Photography";
import Drone from "./pages/Drone";
import FPV from "./pages/FPV";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-800 antialiased">
      <HashRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/photography" element={<Photography />} />
            <Route path="/drone" element={<Drone />} />
            <Route path="/fpv" element={<FPV />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </HashRouter>
    </div>
  );
}

export default App;
